import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useGetList, useUpdate } from "react-admin";
import type { FieldValues } from "react-hook-form";
import type { Student } from "../providers/studentsProvider";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Form2 } from "../misc/Form2";
import { Column } from "../misc/Column";
import { SelectInput } from "../inputs/SelectInput";
import { SaveButton2 } from "../buttons/SaveButton2";
import type { DialogProps } from "../misc/DialogProps";
import { ExamLocation } from "../providers/examLocationsProvider";

export function EditPracticalExamLocationDialog(props: { student: Student } & DialogProps) {
  const { student, ...dialogProps } = props;
  return (
    <Dialog {...dialogProps} maxWidth="sm" fullWidth>
      <DialogTitle>Prüfungsort bearbeiten</DialogTitle>
      <DialogCloseButton onClick={dialogProps.onClose} />
      <_Form student={student} closeDialog={dialogProps.onClose} dialogOpen={dialogProps.open} />
    </Dialog>
  );
}

function _Form(props: { student: Student; closeDialog: () => void; dialogOpen: boolean }) {
  const { student, closeDialog, dialogOpen } = props;
  const [update] = useUpdate();
  const { data: examLocations = [] } = useGetList<ExamLocation>(
    "examLocations",
    { filter: { drivingSchoolId: student.drivingSchoolId, deleted: false }, pagination: { page: 1, perPage: 999 } },
    { enabled: dialogOpen },
  );

  const options: Array<[string, string]> = examLocations.map((loc) => [loc.id, loc.name]);

  const onSubmit = async (formData: FieldValues) => {
    await runSafely(
      () =>
        update(
          "students",
          {
            id: student.id,
            data: { practicalExamLocationUid: formData.practicalExamLocationUid },
            previousData: student,
          },
          { returnPromise: true },
        ),
      {
        errorMessage: "Fehler beim Aktualisieren des Prüfungsorts.",
        successMessage: "Prüfungsort erfolgreich aktualisiert.",
        onSuccess: closeDialog,
      },
    );
  };

  return (
    <Form2 onSubmit={onSubmit} defaultValues={{ practicalExamLocationUid: student.practicalExamLocationUid ?? "" }}>
      <DialogContent>
        <Column spacing={2}>
          <SelectInput source="practicalExamLocationUid" label="Prüfungsort" options={options} />
        </Column>
      </DialogContent>
      <DialogActions>
        <SaveButton2 />
      </DialogActions>
    </Form2>
  );
}
